import type { Account, OwnedAccount, SiteAccount } from '@hotjar/account';
import { keysToSnakeCase } from '@hotjar/webapp/lib/convert-string';
import { extractAccountGroupingProps } from '@hotjar/webapp/tracking/utils';
import * as Segment from './tools/segment';

interface CompanyDetailsFormSubmittedArgs {
  countrySelectChanged: boolean;
  taxFieldFilled: boolean;
  taxFieldPresent: boolean;
  success: boolean;
  failureReason?: string;
}

/**
 * Company details modal has been submitted
 */
export const companyDetailsFormSubmitted = (
  args: CompanyDetailsFormSubmittedArgs,
  account: Account | SiteAccount | OwnedAccount,
): void => {
  Segment.track('Company Details Form Submitted', {
    ...keysToSnakeCase(args),
    ...extractAccountGroupingProps(account),
  });
};
